// extracted by css-extract-rspack-plugin
export default {"PopoverContent":"CopilotPopover-module__PopoverContent__gY_w0"};